// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V7H22V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 9V22H22V9H2ZM5 12H7.00391V14.0039H5V12ZM9 12H11.0039V14.0039H9V12ZM13 12H15.0039V14.0039H13V12Z"}}]};

const SystemInterfaceFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-interface-filled',
    ref,
    icon: element,
  },
));

SystemInterfaceFilledIcon.displayName = 'SystemInterfaceFilledIcon';

export default SystemInterfaceFilledIcon;
